module.exports = __webpack_public_path__ + "img/eSupply.2e128c2b.png";